export default class {
  constructor(url) {
    this.url = url;
  }


  index(params) {
    return axios.get(this.url, {
      params,
    });
  }


  show(id, params = {}) {
    return axios.get(`${ this.url }/${ id }`, {
      params,
    });
  }


  store(data) {
    return axios.post(this.url, data);
  }


  update(id, data) {
    return axios.put(`${ this.url }/${ id }`, data);
  }


  delete(id, params = {}) {
    return axios.delete(`${ this.url }/${ id }`, {
      params,
    });
  }
}
